import React, { useEffect, useState } from 'react';
import {
  Box, TextField, Container, Grid, Card, CardContent, Divider, Button, styled, Switch,
  FormControlLabel, Snackbar, Alert, MenuItem, Select, FormControl, Typography, InputLabel,
  CircularProgress,
  recomposeColor,
  Autocomplete
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { get, multy_post } from 'src/services/httpClient.service';
import axios from 'axios';
import InputAdornment from '@mui/material/InputAdornment';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';

import { authenticationService } from "src/services";

const StyledButton = styled(Button)({
  backgroundColor: '#1976D2',
  color: 'white',
  borderRadius: '4px',
  padding: '8px 12px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#1565C0',
  },
});

const AddChannel = (props) => {
  const { localAddressList = [] } = props;
  const {vendorId, franchiseId} = authenticationService.getVendorFranchiseIds();
  const { showSnackbar } = useSnackbar();
  const [formValues, setFormValues] = useState({
  /*   channelId: '', */
    lcNo:'',
    application: '',
    channelName: '',
    channelUrl: '',
    udp:'',
    imageFileName: '',
    bannerFileName: null,
    bannerFileNameWithExtension: '',
    folder: 'channel',
    vendorId: 3,
    mpegtsAudioPID: 0,
    mpegtsVideoPID: 0,
    programPID: 0,
    recentlyAdded: false,
    popular: false,
    premium: false,
    thumbnail: null,
    packages: '',
    packageId: '',
    language: '',
    isPaidChannel: true,
    price: 0,
    transcoder: true,
    created_date: new Date().toISOString().split('T')[0],
    updated_date: new Date().toISOString().split('T')[0],
    broadcasterId: '',
    broadcasterName: '',
    status: 'ACTIVE',
    streamId: '',
    localAddress: ''
  });

  const [bannerPreview, setBannerPreview] = useState(null);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);
  const [thumbnailError, setThumbnailError] = useState('');
  const [bannerError, setBannerError] = useState('');
  const [categories, setCategories] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [packages, setPackages] = useState([]);
  const [streamIps, setStreamIps] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState('');
  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(null);
  const [broadcasters, setBroadcasters] = useState([]);
  const [selectedBroadcaster, setSelectedBroadcaster] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [successMsg, setSuccessMsg] = useState('Channel added successfully.');
  const [errorMsg, setErrorMsg] = useState('Failed to add channel. Please try again.');
  const [isloading,setIsloading] = useState(false)
  const [categoryMap, setCategoryMap] = useState({});
 
  interface ChannelForm {
  /*   channelId: string; */
    lcNo:string;
    application: string;
    channelName: string;
    channelUrl: string;
    language: string;
    price: string;
    broadcasterId: string;
    status: string;
    streamId: string;
  }
  const [validationErrors, setValidationErrors] = useState<Partial<Record<keyof ChannelForm, string>>>({});
  const requiredFields = {
    /* channelId: 'Please enter Channel ID', */
    lcNo:'Please select Application',
    application: 'Please select Application',
    channelName: 'Please enter Channel Name',
    channelUrl: 'Please enter Channel URL',
    language: 'Please select Language',
    price: 'Please enter Price',
    broadcasterId: 'Please select Broadcaster',
    streamId: 'Please enter Stream ID',
    numberValidation: []
  };

  useEffect(() => {
    fetchLanguages();
    fetchPackages();
    fetchCategories();
    fetchBroadcasters();
    fetchServerIps();
  }, []);

  const fetchBroadcasters = async () => {
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_BROADCASTER}/${vendorId}`);
      if (Array.isArray(response)) {
        setBroadcasters(response);
      } else {
        console.error('Invalid data format for broadcasters:', response);
      }
    } catch (error) {
      console.error('Error fetching broadcasters:', error);
    }
  };

  const fetchLanguages = async () => {
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_LANGUAGES}`);
      if (Array.isArray(response)) {
        setLanguages(response);
      } else {
        console.error('Invalid data format for languages:', response);
      }
    } catch (error) {
      console.error('Error fetching languages:', error);
    }
  };

  const fetchPackages = async () => {
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}/vendor/${vendorId}/findAll`);
      if (Array.isArray(response)) {
        setPackages(response);
      } else {
        console.error('Invalid data format for packages:', response);
      }
    } catch (error) {
      console.error('Error fetching packages:', error);
    }
  };

  const fetchServerIps = async () => {
    try {
      const response = await get(`${process.env.REACT_APP_BASE_API_URL}/api/vendor-streams/vendor/${vendorId}/findAll`);
       console.log('response1',response)
      if (Array.isArray(response?.data)) {

        // show only STREAM serverType
      const filteredStreams = response?.data?.filter(
        (stream) => stream.serverType === "STREAM"
      );
        setStreamIps(filteredStreams);

      } else {
        console.error('Invalid data format for stream IPs:', response);
      }
    } catch (error) {
      console.error('Error fetching stream IPs:', error);
    }
  };

  const fetchCategories = async () => {
  try {
    const response = await get(
      `${process.env.REACT_APP_BASE_API_URL}/categories/vendor/${vendorId}/findAll`
    );

    if (Array.isArray(response?.data)) {

      const uniqueCategories = [];
      const seen = new Set();

      response.data.forEach((category) => {

        let streamIds = [];

        if (category.streamIds) {
          try {
            streamIds = JSON.parse(category.streamIds);
          } catch {
            streamIds = category.streamIds
              .replace("[", "")
              .replace("]", "")
              .split(",")
              .map(id => id.trim())
              .filter(Boolean);
          }
        }

        

        if (!seen.has(category.name)) {
          seen.add(category.name);

          uniqueCategories.push({
            id: category.id,
            name: category.name,
            streamIds
          });
        }
      });
      const map = {};

        uniqueCategories.forEach(category => {
          category.streamIds.forEach(id => {

            if (!map[id]) {
              map[id] = [];
            }

            map[id].push(category);
          });
        });

        setCategoryMap(map);

      setCategories(uniqueCategories);
      setAllCategories(uniqueCategories);
    }

  } catch (error) {
    console.error(error);
  }
};

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };
const handleCategoriesByStreamId = (e) => {

  const selectedId = e.target.value;

  setFormValues(prev => ({
    ...prev,
    streamId: selectedId,
    application: ""
  }));

  setCategories(categoryMap[selectedId] || []);
};

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    if (!file) return;

    const isValidType = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type);
    const reader = new FileReader();
    const img = new Image();

    img.onload = () => {
      if (fileType === 'thumbnail') {
        if (!isValidType || img.width !== 400 || img.height !== 400) {
          setThumbnailError('Logo must be 400x400 pixels in JPG, GIF, or PNG format.');
          setThumbnailPreview(null);
          setFormValues({ ...formValues, thumbnail: null, imageFileName: '' });
        } else {
          setThumbnailError('');
          reader.onloadend = () => {
            setThumbnailPreview(reader.result);
            const fileNameWithExtension = `${file.name.split('.')[0]}.${file.type.split('/')[1]}`;
            setFormValues({ 
              ...formValues, 
              thumbnail: file, 
              imageFileName: fileNameWithExtension 
            });
          };
          reader.readAsDataURL(file);
        }
      } else if (fileType === 'bannerFileName') {
        if (!isValidType || img.width !== 500 || img.height !== 296) {
          setBannerError('Landscape Logo must be 500x296 pixels in JPG, GIF, or PNG format.');
          setBannerPreview(null);
          setFormValues({ ...formValues, bannerFileName: null, bannerFileNameWithExtension: '' });
        } else {
          setBannerError('');
          reader.onloadend = () => {
            setBannerPreview(reader.result);
            const fileNameWithExtension = `${file.name.split('.')[0]}.${file.type.split('/')[1]}`;
            setFormValues({ 
              ...formValues, 
              bannerFileName: file, 
              bannerFileNameWithExtension: fileNameWithExtension 
            });
          };
          reader.readAsDataURL(file);
        }
      }
    };

    img.src = URL.createObjectURL(file);
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    
    const numberValidationFields = requiredFields.numberValidation || [];

    // Remove numberValidation key from requiredFields before loop
    const validationKeys = Object.keys(requiredFields).filter(key => key !== 'numberValidation');

    const newErrors = {};

    validationKeys.forEach((key) => {
      const value = formValues[key];
      
      // Check for empty fields
      if (
  value === null ||
  value === undefined ||
  (typeof value === 'string' && value.trim() === '')
) {
  newErrors[key] = requiredFields[key];
}

      // If key needs number validation, check if value > 0
      if (numberValidationFields.includes(key)) {
        const num = Number(value);
        if (!num || num <= 0) {
          newErrors[key] = requiredFields[key];
        }
      }
    });

    if (Object.keys(newErrors).length > 0) {
      setValidationErrors(newErrors);  // You should define validationErrors state
      setErrorMsg('Please fill the mandatory fields.');
      setDeleteStatus('error');
      setOpenSnackbar(true);
      return; // Don't proceed if validation fails
    }
     // ===== Logo & Banner Mandatory Validation  =====
    let fileValidationFailed = false;

    if (!formValues.thumbnail) {
      setThumbnailError('Logo is required (400x400 JPG, PNG, or GIF).');
      fileValidationFailed = true;
    }

    if (!formValues.bannerFileName) {
      setBannerError('Landscape Logo is required (500x296 JPG, PNG, or GIF).');
      fileValidationFailed = true;
    }

    if (fileValidationFailed) {
      setDeleteStatus('error');
      setErrorMsg('Please upload mandatory images.');
      setOpenSnackbar(true);
      return; // ❌ Stop submission
    }
    
    
    if ( /* !formValues.channelId || */ !formValues.application || !formValues.channelName || !formValues.channelUrl || !formValues.streamId
    ) {
      setDeleteStatus('error');
      setOpenSnackbar(true);
      return;
    } 
    try {
      const formData = new FormData();

      const channelRequest = {
      /*   channelId: formValues.channelId, */
        lcNo: formValues.lcNo,
        channelName: formValues.channelName,
        application: formValues.application,
        folder: formValues.folder,
        channelUrl: formValues.channelUrl,
        udp: formValues.udp,
        vendorId:vendorId,
        mpegtsAudioPID: formValues.mpegtsAudioPID,
        mpegtsVideoPID: formValues.mpegtsVideoPID,
        programPID: formValues.programPID,
        recentlyAdded: formValues.recentlyAdded,
        popular: formValues.popular,
        premium: formValues.premium,
        packages: formValues.packages,
        packageId: formValues.packageId,
        language: formValues.language,
        isPaidChannel: formValues.isPaidChannel,
        price: formValues.price,
        broadcasterId: formValues.broadcasterId,
        broadcasterName: formValues.broadcasterName,
        streamId: formValues.streamId,
        status: formValues.status,
        transcoder: formValues.transcoder,
        localAddress: formValues.localAddress,
        franchiseId:franchiseId
      };

      const channelRequestBlob = new Blob([JSON.stringify(channelRequest)], {
        type: 'application/json',
      });
      formData.append('channelRequest', channelRequestBlob);

      if (formValues.thumbnail) {
        formData.append('thumbnail', formValues.thumbnail, formValues.imageFileName);
      }

      if (formValues.bannerFileName) {
        formData.append('banner', formValues.bannerFileName, formValues.bannerFileNameWithExtension);
      }

      console.log('formValues1',formValues)
       setIsloading(true)
      const response = await multy_post(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_CHANNELS}`, formData);
console.log('response',response)
    
      if (response && response.responseCode === "200") {

        setIsloading(false)
        
        setFormValues({
         /*  channelId: '', */
          lcNo:'',
          application: '',
          channelName: '',
          channelUrl: '',
          udp:'',
          imageFileName: '',
          bannerFileName: null,
          bannerFileNameWithExtension: '',
          folder: 'channel',
          vendorId: 3,
          mpegtsAudioPID: 0,
          mpegtsVideoPID: 0,
          programPID: 0,
          recentlyAdded: false,
          popular: false,
          premium: false,
          thumbnail: null,
          packages: '',
          packageId: '',
          language: '',
          isPaidChannel: true,
          price: 0,
          transcoder: true,
          created_date: new Date().toISOString().split('T')[0],
          updated_date: new Date().toISOString().split('T')[0],
          broadcasterId: '',
          broadcasterName: '',
          status: 'ACTIVE',
          streamId: '',
          localAddress: ''
        });
        /* setDeleteStatus('success'); */
        props.handleClose();
        showSnackbar('Added Channel successfully', 'success');
        setIsloading(false)
  
      // } else {
      //   setDeleteStatus('error');
      }
    } catch (error) {
      //console.log(error.response.data['data'])
      //console.error('Error adding channel:', error);
      showSnackbar(error.response.data['data'], 'error');
      setIsloading(false)
      /* setErrorMsg(error.response.data['data']); */
     /*  setDeleteStatus('error'); */
      showSnackbar(error.response.data['data'], 'error');
    }

    setOpenSnackbar(true);
  };

  return (
    <>
      <Helmet>
        <title>Add Channel</title>
      </Helmet>

      {isloading?<Box sx={{display:"flex",flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                  <CircularProgress/>
                <Typography variant='h4'>Adding Channel Processing ....</Typography></Box>:
      <Container maxWidth="lg" sx={{ paddingBottom: '25px' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card sx={{ boxShadow: 3 }}>
              <Divider />
              <CardContent>
                <Box sx={{ marginBottom: '20px' }}>
                  <Box sx={{ boxShadow: 0, p: 3, borderRadius: 2 }}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="streamId"
                          name="streamId"
                          select
                          value={formValues.streamId}
                          label="Stream IP"
                          fullWidth
                          onChange={handleCategoriesByStreamId}
                          error={!!validationErrors.streamId}
                        >
                          {streamIps.filter(rec => rec.status == 'ACTIVE').map((stream) => (
                            <MenuItem key={stream.id} value={stream.id}>
                              {stream.name} ( {stream.url} ) 
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="folder"
                          name="folder"
                          value={formValues.folder}
                          label="Folder"
                          fullWidth
                          InputProps={{ readOnly: true }}
                        />
                      </Grid> */}

                      

                      {/* <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="channelId"
                          name="channelId"
                          value={formValues.channelId}
                          label="Channel ID"
                          fullWidth
                          onChange={handleChange}
                          error={!!validationErrors.channelId}
                        />
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="lcNo"
                          name="lcNo"
                          value={formValues.lcNo}
                          label="LCN"
                          fullWidth
                          onChange={handleChange}
                          error={!!validationErrors.lcNo}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="udp"
                          name="udp"
                          value={formValues.udp}
                          label="UDP"
                          fullWidth
                          onChange={handleChange}
                          
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="channelName"
                          name="channelName"
                          value={formValues.channelName}
                          label="Channel Name"
                          fullWidth
                          onChange={handleChange}
                          error={!!validationErrors.channelName}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
  <Autocomplete
    freeSolo
    options={localAddressList}
    value={formValues.localAddress}
    onChange={(event, newValue) => {
      setFormValues({
        ...formValues,
        localAddress: newValue || ""
      });
    }}
    onInputChange={(event, newInputValue) => {
      setFormValues({
        ...formValues,
        localAddress: newInputValue
      });
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Local Address"
        fullWidth
      />
    )}
  />
</Grid>
                  {formValues.streamId && <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="application"
                          name="application"
                          select
                          value={formValues.application}
                          label="Category"
                          fullWidth
                          onChange={handleChange}
                          error={!!validationErrors.application}
                        >
                          {categories.map((category) => (
                            <MenuItem key={category.id} value={category.name}>
                              {category.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>}    
                      {/* <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="packages"
                          name="packages"
                          select
                          value={selectedPackage}
                          label="Packages"
                          fullWidth
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            const selectedPkg = packages.find(pkg => pkg.id === selectedId);
                            setSelectedPackage(selectedId);
                            setFormValues({
                              ...formValues,
                              packageId: selectedId,
                              packages: selectedPkg?.planName
                            });
                          }}
                        >
                          {packages.map((pkg) => (
                            <MenuItem key={`${pkg.id}-${pkg.planName}`} value={pkg.id}>
                              {pkg.planName}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="language"
                          name="language"
                          select
                          value={selectedLanguage}
                          label="Language"
                          fullWidth
                          onChange={(e) => {
                            setSelectedLanguage(e.target.value);
                            setFormValues({ ...formValues, language: e.target.value });
                          }}
                          error={!!validationErrors.language}
                        >
                          {languages.map((language) => (
                            <MenuItem key={language} value={language}>
                              {language}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="broadcaster"
                          name="broadcaster"
                          select
                          value={selectedBroadcaster}
                          label="Broadcaster"
                          fullWidth
                          onChange={(e) => {
                            const selectedId = e.target.value;
                            const selectedBroadcasterObj = broadcasters.find(b => b.id === selectedId);
                            setSelectedBroadcaster(selectedId);
                            setFormValues({
                              ...formValues,
                              broadcasterId: selectedId,
                              broadcasterName: selectedBroadcasterObj?.name || ''
                            });
                          }}
                          error={!!validationErrors.broadcasterId}
                        >
                          {broadcasters.filter(rec => rec.status == 'ACTIVE').map((broadcaster) => (
                            <MenuItem key={broadcaster.id} value={broadcaster.id}>
                              {broadcaster.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                        <FormControl fullWidth required>
                          <InputLabel id="status-label">Status</InputLabel>
                          <Select
                            labelId="status-label"
                            id="status"
                            name="status"
                            value={formValues.status}
                            onChange={(e) =>
                              setFormValues({
                                ...formValues,
                                status: e.target.value
                              })
                            }
                            error={!!validationErrors.status}
                          >
                            <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                            <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <TextField
                          required
                          id="channelUrl"
                          name="channelUrl"
                          value={formValues.channelUrl}
                          label="Channel URL"
                          fullWidth
                          onChange={handleChange}
                          error={!!validationErrors.channelUrl}
                        />
                      </Grid>
                      
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="mpegtsAudioPID"
                          name="mpegtsAudioPID"
                          value={formValues.mpegtsAudioPID}
                          label="Audio PID"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="mpegtsVideoPID"
                          name="mpegtsVideoPID"
                          value={formValues.mpegtsVideoPID}
                          label="Video PID"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          id="programPID"
                          name="programPID"
                          value={formValues.programPID}
                          label="Program PID"
                          fullWidth
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <TextField
                          required
                          id="price"
                          name="price"
                          value={formValues.price}
                          label="Price/month"
                          type="number"
                          fullWidth
                          onChange={handleChange}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">₹</InputAdornment>
                            ),
                          }}
                          error={!!validationErrors.price}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              id="isPaidChannel"
                              name="isPaidChannel"
                              checked={formValues.isPaidChannel}
                              onChange={handleChange}
                            />
                          }
                          label="Is Paid Channel"
                        />
                      </Grid>
                      {/* <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              id="transcoder"
                              name="transcoder"
                              checked={formValues.transcoder}
                              onChange={handleChange}
                            />
                          }
                          label="Transcoder (720p)"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              id="recentlyAdded"
                              name="recentlyAdded"
                              checked={formValues.recentlyAdded}
                              onChange={handleChange}
                            />
                          }
                          label="Recently Added"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Switch
                              id="popular"
                              name="popular"
                              checked={formValues.popular}
                              onChange={handleChange}
                            />
                          }
                          label="Popular"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Switch
                              id="premium"
                              name="premium"
                              checked={formValues.premium}
                              onChange={handleChange}
                            />
                          }
                          label="Premium"
                        />
                      </Grid> */}
                      <Grid item xs={12} sm={6}>
                        <label htmlFor="thumbnailInput">
                          <StyledButton as="span">
                            {formValues.thumbnail ? formValues.thumbnail.name : 'Choose Logo'}
                          </StyledButton>
                        </label>
                        <input
                          id="thumbnailInput"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleFileChange(e, 'thumbnail')}
                          style={{ display: 'none' }}
                        />
                        {thumbnailError && (
                          <div style={{ color: 'red', marginTop: '5px' }}>{thumbnailError}</div>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <label htmlFor="bannerInput">
                          <StyledButton as="span">
                            {formValues.bannerFileName ? formValues.bannerFileName.name : 'Landscape Logo'}
                          </StyledButton>
                        </label>
                        <input
                          id="bannerInput"
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleFileChange(e, 'bannerFileName')}
                          style={{ display: 'none' }}
                        />
                        {bannerError && (
                          <div style={{ color: 'red', marginTop: '5px' }}>{bannerError}</div>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {thumbnailPreview && (
                          <img
                            src={thumbnailPreview}
                            alt="Thumbnail Preview"
                            style={{ maxWidth: '50%', maxHeight: '100px', marginTop: '10px' }}
                          />
                        )}
                        {!thumbnailPreview && <Typography color={'blue'} variant="body2" gutterBottom >*Note:  Logo must be 400x400 pixels in JPG, GIF, or PNG format</Typography>}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {bannerPreview && (
                          <img
                            src={bannerPreview}
                            alt="Banner Preview"
                            style={{ maxWidth: '50%', maxHeight: '100px' }}
                          />
                        )}
                        {!bannerPreview &&  <Typography color={'blue'} variant="body2" gutterBottom>*Note: Landscape Logo must be 500x296 pixels in JPG, GIF, or PNG format.</Typography>}
                      </Grid>
                    </Grid>
                  </Box>
                  {/* <Snackbar
                    open={openSnackbar}
                    autoHideDuration={6000}
                    onClose={() => setOpenSnackbar(false)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    sx={{ zIndex: 1600 }}  // Adjust the z-index here
                  >
                    <Alert
                      onClose={() => setOpenSnackbar(false)}
                      severity={deleteStatus === 'success' ? 'success' : 'error'}
                      sx={{
                        backgroundColor: deleteStatus === 'success' ? '#2e7d32' : '#c62828',
                        color: '#fff',
                        fontWeight: 'bold',
                      }}
                    >
                      {deleteStatus === 'success'
                        ? successMsg
                        : errorMsg}
                    </Alert>
                  </Snackbar> */}
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                      sx={{ marginRight: '10px' }}
                      onClick={props.handleClose}
                      variant="outlined"
                      color="primary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleSubmit}
                      variant="contained"
                      color="primary"
                    >
                      Submit
                    </Button>
                  </Box>
                </Box>
                
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>}
    </>
  );
};

export default AddChannel;